import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: ${vars.sectionPadding};

	.bundle {
		display: flex;
		justify-content: space-between;
		align-items: stretch;

		.image-container {
			.bundle-image {
				object-fit: cover;
				height: 100%;
				width: 100%;
				border-radius: 20px;
			}
		}

		.mobile-image-wrapper {
			display: none;

			.discount-mobile {
				display: none;
			}
		}

		.content-container {
			box-shadow: 0 0 1em #0000001f;
			border-radius: 2em;
			padding: 2.5em;
			display: flex;
			flex-direction: column;

			.special-offer-labels {
				display: flex;
				gap: 0.5em;
				border-bottom: none;
				padding-bottom: 1em;
				left: 0;

				.label {
					padding: 0.5em 1em;
					border-radius: 0.4em;
					font-size: 10px;
					color: #fff;
					background-color: #ba9449;
				}
			}

			.discount-desktop {
				position: absolute;
				top: -1em;
				right: 1em;
				color: white;
				font-weight: 700;
				padding: 3px 6px;
				border-radius: 10px;
				font-size: 25px;
				min-width: 111px;
				min-height: 38px;
				display: flex;
				place-content: center;
				place-items: center;
				background: transparent
					linear-gradient(275deg, #819367 0%, #9aaa79 44%, #b8d17e 100%) 0% 0%
					no-repeat padding-box;
				box-shadow: 0px 1px 10px #00000036;
			}

			.old-price-wrapper {
				font-size: 12px;
				display: flex;
				flex-direction: column;
				width: 100%;
				margin-bottom: 1em;
				color: #9c9c9c;

				.offer-duration-container {
					display: flex;
					align-items: center;
					justify-content: flex-start;
				}

				.last-month-price-container {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					font-size: 15px;
					gap: 0.2em;

					.info-mark {
						position: relative;
						width: 14px;
						height: 14px;
						display: flex;
						align-items: center;
						justify-content: center;
						border: 1px solid #9c9c9c;
						border-radius: 15px;
						margin-right: 4px;
						font-size: 10px;

						&:after {
							position: absolute;
							content: '';
							left: -50%;
							top: -50%;
							width: 200%;
							height: 200%;
							background-color: transparent;
						}

						&:hover {
							.info-mark__information {
								opacity: 1;
								transform: translateY(0);
							}
						}

						&__information {
							position: absolute;
							bottom: calc(100% + 6px);
							left: 0;
							width: 240px;
							background-color: white;
							box-shadow: -1px 4px 10px rgba(0, 0, 0, 0.15);
							padding: 6px;
							border-radius: 12px 12px 12px 0;
							color: black;
							opacity: 0;
							pointer-events: none;
							transform: translateY(4px);
							transition: opacity 200ms ease, transform 200ms ease;
						}
					}
				}

				span {
					margin-left: 2px;
				}
			}

			.header {
				.headline {
					font-size: 27px;
					font-weight: 700;
					line-height: 1.2;
					color: #262626;
					margin-bottom: 10px;

					* {
						font-size: 27px;
					}
				}

				.price-data-container {
					width: 100%;

					.prices-container {
						display: flex;
						align-items: flex-start;
						flex-direction: row wrap;
						place-items: center;
						gap: 1.5em;

						.pricing-price {
							font-size: 25px;
							font-weight: ${vars.fontBlack};
							color: #3b3c43;
						}

						.pricing-old-price {
							font-size: 18px;
							font-weight: ${vars.fontBold};
							color: ${vars.colorTextLight};
							text-decoration: line-through;
						}
					}
				}

				.description {
					color: #3b3c43;
					margin-top: 1em;
					display: flex;
					flex-direction: column;
					gap: 0.5em;
					font-size: 17px;
				}
			}

            .package-list {
                display: flex;
                flex-direction: column;
                row-gap: 0.3em;
                border-bottom: .1em solid #ececec;
                padding: 2em 0;

                .package-item {
                    display: flex;
                    align-items: center;

                    .package-item-icon {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        min-width: 2em;
                        min-height: 2em;
                        margin-right: .5em;
                        padding: 0em;

                        .icon {
                            min-width: 32px;
                            min-height: 26px;
                        }
                    }

                    .content {
                        font-size: .9em;
                        max-width: 75%;
                    }
                }
            }

			.content-list {
				padding: 1.5em 0 0 0;
				font-size: 19px;

				.content {
					color: #3b3c43;
					display: flex;
					flex-direction: column;
					gap: 0.5em;
					margin: 0;

					.title {
						display: flex;
						align-items: center;

						.icon {
							color: #ba9449;
							margin-right: 0.5em;
							width: 1em;
						}

						.title-gold {
							color: ${vars.colorGold};
							margin: 0 0.5em 0 0;
						}
					}
				}
			}

            .paypo-banner {
				display: flex;
				align-items: center;
				column-gap: 1.5em;
				padding: 1.5em 0;
				border-bottom: 0.1em solid #ececec;

				.paypo-logo {
					max-width: 50%;
					max-height: 1.5em;
				}

				.paypo-title {
					font-size: 0.9em;
					font-weight: 700;
					.paypo-subtitle {
						color: #36b588;
					}
				}
			}

			.footer {
				display: flex;
				flex-flow: column wrap;
				justify-content: space-between;
				align-items: flex-end;
				min-width: 100%;
				height: 100%;
				padding: 2em 0;
				gap: 1em;

				.footer-controls-state {
					width: 100%;
				}

				.footer-controls {
					display: flex;
					justify-content: space-between;
					align-items: center;
					min-width: 100%;
					gap: 1em;

					> * {
						min-width: 35%;
					}
				}
			}
		}

		> * {
			width: 47%;
		}

		.instalments {
			margin: 0.2em auto 0.3em auto;
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		padding: 0;
		border-radius: 0;

		.layout-container {
			width: 100%;
		}

		.bundle {
			text-align: center;
			justify-content: center;

			.image-container {
				display: none;
			}

			.mobile-image-wrapper {
				display: block;
				width: calc(100% + 4em);
				margin: 2em 0;
				border-radius: 2em;
				height: 22em;
				transform: translateX(-2em);

				.bundle-image-mobile {
					height: 100%;
					object-fit: cover;
					border-radius: 10px 10px 0px 0px;
					box-shadow: 0px 3px 6px #00000029;
					width: 100%;
				}

				.discount-mobile {
					position: absolute;
					bottom: -1em;
					right: 1em;
					color: white;
					font-weight: 700;
					padding: 3px 6px;
					border-radius: 10px;
					font-size: 22px;
					min-width: 79px;
					min-height: 35px;
					display: flex;
					place-content: center;
					place-items: center;
					background: transparent
						linear-gradient(275deg, #819367 0%, #9aaa79 44%, #b8d17e 100%) 0% 0%
						no-repeat padding-box;
					box-shadow: 0px 1px 10px #00000036;
				}
			}

			.content-container {
				width: 100%;
				padding: 2em;

				.discount-desktop {
					display: none;
				}

				.header {
					.headline {
						font-size: 22px;

						* {
							font-size: 22px;
						}
					}

					.price-data-container {
						justify-content: center;

						.prices-container {
							.pricing-price {
								font-size: 22px;
							}
							.pricing-old-price {
								font-size: 17px;
							}
						}
					}

					.description {
						text-align: justify;
						font-size: 14px;
					}
				}

				.content-list {
					font-size: 15px;

					.content {
						text-align: left;
					}
				}

				.footer {
					.footer-controls {
						.public-layout-offer-buy-now-button,
						.public-layout-offer-add-to-cart-button {
							min-width: 47%;
						}
					}
				}
			}
		}
	}
`;
